import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { constantField, Form, textBox } from "trader.ts/ui.forms";
import { image_id, student_link_id } from "../../../sql/classy/types";
import * as style from "../../../styles/style.css.classes";
import { arrayField } from "../../client/arrayfield";
import { fileInputFieldForImage } from "../../client/fileinput";
import { renderSaveButton } from "../../client/savebutton";
import { fileb64 } from "../../lib/base64";
import { mandatoryValidation, urlValidation } from "../../lib/validate";
import * as routes from "../../routes";

export function render(opts: {
  allStudentLinks: {
    id: student_link_id;
    title: string;
    description: string;
    url: string;
    image_id: image_id | null;
    ordering: number;
  }[];
}): HTMLElement | HTMLElement[] {
  const form = new Form({})
    .addField("student_links", [], () =>
      arrayField<{
        id: student_link_id | null;
        title: string;
        description: string;
        url: string;
        image_id:
          | image_id
          | {
              data: fileb64;
              mimetype: string;
              name: string;
            }
          | null;
      }>({
        initialVal: opts.allStudentLinks,
        makeNew: () => ({
          id: null,
          title: "",
          description: "",
          url: "",
          image_id: null,
        }),
        makeSubForm: async function (tl) {
          return new Form({})
            .addField("id", [], () => constantField(tl.id))
            .addField("title", [], () =>
              textBox({
                initialVal: tl.title,
                label: "Titel",
                validations: [mandatoryValidation],
              }),
            )
            .addField("description", [], () =>
              textBox({
                initialVal: tl.description,
                label: "Lange beschrijving",
                type: "textarea",
                validations: [],
              }),
            )
            .addField("url", [], () =>
              textBox({
                initialVal: tl.url,
                label: "Link",
                validations: [mandatoryValidation, urlValidation],
              }),
            )
            .addField("image_id", [], async () =>
              fileInputFieldForImage({
                initial: tl.image_id,
                label: "Kleine afbeelding, vierkante resoluties van 128 x 128 passen het best.",
                initiallabel: "Upload hier je afbeelding.",
                selectedlabel: "Afbeelding geselecteerd",
                mkImageLink: function (image_id: image_id): string {
                  return routes.imageRoute.link({ image_id });
                },
                accept: "image/*",
              }),
            )
            .build({
              render: (fields) => (
                <div>
                  <div className={style.equal_columns}>
                    {fields.title()}
                    {fields.url()}
                  </div>
                  {fields.description()}
                  {fields.image_id()}
                </div>
              ),
            });
        },
      }),
    )
    .build();
  return (
    <div>
      <section>{form.render()}</section>
      <div style="text-align: right">
        {renderSaveButton({
          formS: form.s,
          save: (values) => {
            return rpc(routes.saveStudentLinksSpec, undefined, values);
          },
          reload: true,
        })}
      </div>
    </div>
  );
}
